import { track } from "./analytics";
/** Same build-time address sign-in uses (see account.ts); read here directly so the two files do not import each other. */
const RELAY_HTTP: string = (import.meta.env.VITE_RELAY_URL ?? "").replace(/\/+$/, "");


/**
 * Reports the app's own errors (uncaught errors, unhandled promise rejections, a screen that crashed) to the relay's
 * `/log`, so they show up next to the relay's logs. Only the error text and stack and the page's path: never the address
 * hash or query (pairing codes live there), terminal output or keys. Best effort, a few per session, never throws.
 */
const MAX_PER_SESSION = 20;
const sent = new Set<string>();
let count = 0;

export function reportError(kind: string, err: unknown): void {
  try {
    const e = err instanceof Error ? err : new Error(typeof err === "string" ? err : JSON.stringify(err) ?? String(err));
    const key = `${kind}:${e.message}`;
    console.error(`[${kind}]`, err);
    if (!RELAY_HTTP || sent.has(key) || count >= MAX_PER_SESSION) return;
    sent.add(key);
    count++;
    track("app_error", { kind }); // the category only; the message and stack go to the relay's logs, never to PostHog
    const body = JSON.stringify({
      source: "web",
      app: "brocoded-web",
      version: String(import.meta.env.VITE_APP_VERSION ?? "dev"),
      events: [{ level: "error", kind, msg: `${e.name}: ${e.message}`, stack: e.stack, page: location.pathname, at: Date.now() }],
    });
    fetch(`${RELAY_HTTP}/log`, { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => undefined);
  } catch {
    /* reporting an error must never cause one */
  }
}

export function installErrorReporting(): void {
  addEventListener("error", (ev) => reportError("uncaught", ev.error ?? ev.message));
  addEventListener("unhandledrejection", (ev) => reportError("unhandled-rejection", ev.reason));
}
